import * as screens from '@core/layouts/components/menu/screens';
import apiKeysManagementPaths from 'views/screens/ApiKeysManagement/paths';
import apiKeysPermissions from 'views/screens/ApiKeysManagement/permissions';
import businessPartnersPaths from 'views/screens/BusinessPartners/paths';
import Icon from '../../utility/icomoon';

export default [
  {
    id: 'apiKeysManagement',
    title: 'apiKeysManagement.catalog',
    icon: <Icon size={20} icon="Key" />,
    iconName: 'Key',
    permissions: [apiKeysPermissions.apiKeysCatalog],
    navLink: apiKeysManagementPaths.listApiKeys,
    screenId: screens.API_CONSUMPTION
  },
  {
    id: 'apiConsumption',
    title: 'apiKeysManagement.consumptionReportShort',
    icon: <Icon size={20} icon="BarChart2" />,
    iconName: 'BarChart2',
    permissions: [apiKeysPermissions.apiKeysConsumptionReport],
    navLink: apiKeysManagementPaths.consumptionReport,
    screenId: screens.API_CONSUMPTION
  },
  {
    id: 'webServiceRates',
    title: 'partners.webServiceRates',
    icon: <Icon size={20} icon="WebService" />,
    iconName: 'WebService',
    permissions: [],
    emailDomain: '@webtrackgps.net',
    navLink: businessPartnersPaths.webServiceRates,
    screenId: screens.WEB_SERVICE_RATES
  }
];
